// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorCoverageAreaModel {
    static getAttributeTypeMap() {
        return PayorCoverageAreaModel.attributeTypeMap;
    }
}
PayorCoverageAreaModel.discriminator = undefined;
PayorCoverageAreaModel.attributeTypeMap = [
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "externalIdType",
        "baseName": "externalIdType",
        "type": "PartyExternalIdType"
    },
    {
        "name": "externalId",
        "baseName": "externalId",
        "type": "string"
    }
];
//# sourceMappingURL=payorCoverageAreaModel.js.map